import { type ReactNode } from 'react';
import { EffetaLogo } from '@/components/ui/icons/effeta-logo';

// Marco de las pantallas públicas de autenticación: entrada (`/login`, con
// sus errores y "sin acceso"), "Saliste del PIM" y "Effetá Apps no responde".
// Pantalla completa, contenido centrado y el logo arriba de la tarjeta.
//
// Existe para que el logo no dependa de que cada página se acuerde de
// ponerlo: son las únicas vistas fuera del layout de la app.

interface AuthScreenProps {
  children: ReactNode;
}

export const AuthScreen = ({ children }: AuthScreenProps) => {
  return (
    <div className="bg-bg flex min-h-screen flex-col items-center justify-center gap-6 p-4">
      <EffetaLogo className="text-secondary h-12 w-auto dark:text-white" aria-label="Effetá" />
      {children}
    </div>
  );
};
